import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { generatePositionTableRow } from '../CallsheetUtils';
import i18n from '../../../i18n';
import styles from '../../../assets/stylesheets/CallsheetInlineStyles';
import CallsheetTable from './CallsheetTable';
import CallsheetSpecialProjectRow from './CallsheetSpecialProjectRow';

class GeneralLocationSheet extends Component {
  render() {
    const { 
      info,
      name,
      renderForEmail,
      locationContacts,
    } = this.props;

    const {
      additionalInfo,
      positionsToList,
      requiredPositions
    } = info;

    return (
      <CallsheetTable
        name={name}
        callTime={info.callTime}
        wrapTime={info.wrapTime}
        locationContacts={locationContacts}
        renderForEmail={renderForEmail}
      >
        {additionalInfo && additionalInfo.map(additionalInfoItem => (
          <Fragment key={`${name}-${additionalInfoItem.label}-frag`}>
            <tr>
              <th colSpan="4" style={styles.tableCell}>
                {i18n.t(additionalInfoItem.label)}
              </th>
            </tr>
            <tr>
              <td colSpan="4" style={styles.tableCell}>
                {additionalInfoItem.value}
              </td>
            </tr>
          </Fragment>
          )
        )}
        <CallsheetSpecialProjectRow
          specialProject={info.specialProject}
        />
        {positionsToList ? positionsToList.map(positionToList =>
          generatePositionTableRow(positionToList.bookingPositionKey, info.positions[positionToList.positionName])
        ) : requiredPositions.map(requiredPosition =>
          generatePositionTableRow(
            requiredPosition.position.i18nLabel,
            info.positions[requiredPosition.position.positionName]
          )
        )}
      </CallsheetTable>
    )
  }
}

GeneralLocationSheet.propTypes = {
  locationContacts: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  name: PropTypes.string.isRequired,
  info: PropTypes.shape({
    callTime: PropTypes.string.isRequired,
    wrapTime: PropTypes.string.isRequired,
    specialProject: PropTypes.shape({
      name: PropTypes.string.isRequired,
      notes: PropTypes.string.isRequired
    }),
    positionsToList: PropTypes.arrayOf(PropTypes.shape({
      // key matching localisation assets for position in booking.json
      bookingPositionKey: PropTypes.string,
      positionName: PropTypes.string,
    })),
    additionalInfo: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]))),
    positions: PropTypes.objectOf(
      PropTypes.shape({
        employees: PropTypes.arrayOf(
          PropTypes.shape({ email: PropTypes.string, name: PropTypes.string })
        )
      })
    ).isRequired,
    requiredPositions: PropTypes.arrayOf(
      PropTypes.shape({
        allowDoubleBooking: PropTypes.bool,
        createdAt: PropTypes.string,
        doubleBookingField: PropTypes.node,
        enabled: PropTypes.bool,
        gender: PropTypes.node,
        group: PropTypes.number,
        id: PropTypes.number,
        locationTypeId: PropTypes.number,
        order: PropTypes.number,
        positionId: PropTypes.number,
        updatedAt: PropTypes.string,
        position: PropTypes.shape({ i18nLabel: PropTypes.string, positionName: PropTypes.string })
      })
    ),
  }).isRequired,
  renderForEmail: PropTypes.bool.isRequired,
}

export default GeneralLocationSheet;
